var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGoogleDrive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M17.954 11.279L11.86.163A.316.316 0 0 0 11.585 0H6.1a.376.376 0 0 0-.275.13L.035 10.593c-.03.098-.06.23 0 .327l2.7 5.792a.306.306 0 0 0 .139.225c.05.042.109.064.178.064h11.885a.316.316 0 0 0 .275-.163l2.742-5.231a.315.315 0 0 0 0-.327zm-.792-.164h-5.09L8.947 5.118a.308.308 0 0 0-.043-.116L6.63.654h4.772l5.76 10.461zm-5.802 0H6.091l2.536-5.247 2.733 5.247zM6.09.998l1.238 2.377.935 1.823-2.925 6.038a.425.425 0 0 0-.03.043l-2.259 4.669-2.404-5.16L6.09.998zm8.664 15.348H3.564l2.211-4.577h11.387l-2.408 4.577z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogleDrive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google-drive.0a34a91c.svg";
export { ForwardRef as ReactComponent };